import { Reveal, SectionTag } from "./Reveal";

const chapters = [
  {
    num: "01",
    title: "Drive Consistent Foot Traffic",
    body: "Keep guests coming back regardless of weather or season with year-round indoor sports entertainment.",
    spec: "YEAR-ROUND / WEATHER-PROOF",
  },
  {
    num: "02",
    title: "Unlock Multi-Sport Appeal",
    body: "Instantly switch between 35+ games to engage families, competitive athletes, and corporate groups.",
    spec: "35+ GAMES / EVERY AUDIENCE",
  },
  {
    num: "03",
    title: "Boost Secondary Spend",
    body: "Blend elite gameplay with F&B and event bookings to increase dwell time and average spend.",
    spec: "F&B UPSELLS / EVENT BOOKINGS",
  },
  {
    num: "04",
    title: "Low Maintenance, High ROI",
    body: "Durable tracking tech ensures minimal downtime and rapid return on your investment.",
    spec: "MINIMAL DOWNTIME / RAPID ROI",
  },
];

export default function WhyPlayVerse() {
  return (
    <section id="why" data-testid="why-section" className="py-28 md:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <SectionTag number="01" label="Why PlayVerse" />
          <h2 className="font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl max-w-4xl">
            Game Seven energy, <span className="text-[#00D4FF]">delivered to your patrons.</span>
          </h2>
          <p className="mt-8 text-white/55 leading-relaxed max-w-xl">
            Turn your venue into a high-traffic sports and entertainment
            destination — maximizing revenue per square foot.
          </p>
        </Reveal>

        <div className="mt-20 md:mt-28 space-y-0">
          {chapters.map((c, i) => (
            <Reveal key={c.num} delay={0.05}>
              <div
                data-testid={`why-chapter-${c.num}`}
                className={`group grid md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-t border-white/10 ${i % 2 === 1 ? "md:pl-24" : ""}`}
              >
                <div className="md:col-span-2">
                  <span className="font-mono-pv text-sm text-[#007AFF]">/{c.num}</span>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-heading font-bold tracking-tight text-2xl md:text-3xl group-hover:text-[#00D4FF] transition-colors duration-300">
                    {c.title}
                  </h3>
                </div>
                <div className="md:col-span-6">
                  <p className="text-white/55 leading-relaxed max-w-lg">{c.body}</p>
                  <p className="mt-6 font-mono-pv text-[10px] tracking-[0.25em] text-white/30">{c.spec}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
